import {RequestField} from "./request_field";
import {FieldLevelType, RequestFieldGroup} from "./request_field_group";
import {MetadataField} from "./metadata_field";

export class RequestFieldList {
  [x: string]: any;

  _fields: { [key: string]: RequestField | MetadataField }
  _uiFields: RequestFieldGroup
  _level: FieldLevelType

  constructor(uiFields: RequestFieldGroup, fieldLevel: FieldLevelType = FieldLevelType.Instance) {
    this._uiFields = uiFields
    this._level = fieldLevel
    this._fields = {metadata: new MetadataField()};

    return new Proxy(this, {
      get(target, prop, receiver) {
        const propStr = prop.toString();
        if (target.parent.fieldNames.includes(propStr)) {
          if (!target.rawFields[propStr]) {
            target.rawFields[propStr] = new RequestField(target, propStr);
          }
          return target.rawFields[propStr];
        }
        return Reflect.get(target, prop, receiver);
      },
    })
  }

  get parent() {
    return this._uiFields;
  }

  get rawFields() {
    return this._fields;
  }

  addNewField(name: string, config?: object) {
    if (!this.parent.fieldNames.includes(name)) {
      this.parent.fieldNames.push(name);
      Object.entries(config).forEach(([k, v]) => {
        this[name][k] = v
      })
    } else {
      throw new Error(`Field ${name} already exists in the request fields list`);
    }
  }

  propagate(fieldName: string, prop: string, value: any) {
    if (this.parent.fieldNames.includes(fieldName)) {
      if (this._level === FieldLevelType.Instance) {
        this.propagateValue(this.parent.session, fieldName, prop, value);
      } else if (this._level === FieldLevelType.Session) {
        this.propagateValue(this.parent.transaction, fieldName, prop, value);
      }
    }
  }

  propagateValue(fieldList: RequestFieldList, fieldName: string, prop: string, value: any) {
    if( fieldList.rawFields[fieldName] ) {
      fieldList[fieldName][prop] = value;
    }
  }

  calculatedFields(): Record<string, any> {
    return Object.fromEntries(
      Object.entries(this._fields)
        .filter(([key]) => this.parent.fieldNames.includes(key))
        .map(([fieldName, field]) => [
          fieldName,
          field.calculatedValue()
        ])
    );
  }
}
